/**
 * @format
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { setOfficeId } from 'state/slice/dropDownSlice';
import { Select } from 'antd';

const { Option } = Select;

interface DownlineItem {
  name: string;
  officeId: string;
}

interface OfficeNamesProps {
}

/**
 * Office Names selector component
 * Uses user's officeDownLines from Redux to populate office options
 */
const OfficeNames: React.FC<OfficeNamesProps> = () => {
  const dispatch = useDispatch();

  // Get user data from Redux
  const userData = useSelector((state: RootState) => (state.user as any).userData);
  const userRole = userData?.role;
  const userOfficeId = userData?.officeId;

  // Get selected office ID from Redux
  const selectedOfficeId = useSelector(
    (state: RootState) => (state.dropDown as any).officeId
  );

  // Get offices from user details
  const offices: DownlineItem[] = userData?.officeDownLines?.downlines || [];

  // Determine default office ID based on user role and downlines
  const getDefaultOfficeId = () => {
    // If user is not root_user or root_custo AND has downline access
    if (userRole && !['root_user', 'root_custo'].includes(userRole) && offices.length > 0) {
      // Find the office that matches user's officeId in the downlines
      const matchingOffice = offices.find((office) => office.officeId === userOfficeId);
      if (matchingOffice) {
        return matchingOffice.officeId;
      }
    }
    return undefined;
  };

  const computedDefaultOfficeId = getDefaultOfficeId();

  // Set default office ID on component mount
  React.useEffect(() => {
    if (!selectedOfficeId && computedDefaultOfficeId) {
      dispatch(setOfficeId({ officeId: computedDefaultOfficeId }));
    }
  }, [computedDefaultOfficeId, selectedOfficeId, dispatch]);

  const handleSelectChange = (value: string) => {
    dispatch(setOfficeId({ officeId: value }));
  };

  return (
    <div>
      <Select
        value={selectedOfficeId || undefined}
        onChange={handleSelectChange}
        style={{ width: '100%' }}
        placeholder='Select Office'
        showSearch
        optionFilterProp='children'
        filterOption={(input: string, option: any) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }>
        {offices.map((office) => (
          <Option key={office.officeId} value={office.officeId}>
            {office.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default OfficeNames;
